import { groupBy } from 'lodash';
import { TipoEnvioNotificacao } from 'px-business-components';
import UserTipoNotificacao from '@/enums/user-tipo-notificacao';
import CompradorTipoNotificacao from '@/enums/comprador-tipo-notificacao';

const TIPO_WHATSAPP = TipoEnvioNotificacao.keys.WHATSAPP.key;
const TIPO_EMAIL = TipoEnvioNotificacao.keys.EMAIL.key;

function buildNotificacao(tipoNotificacao, values, entity, entityType, isUser) {
  const whatsappConfiguration = values?.find(c => c.tipoEnvio === TIPO_WHATSAPP);
  const emailConfiguration = values?.find(c => c.tipoEnvio === TIPO_EMAIL);
  const notificacaoConfiguration = isUser
    ? UserTipoNotificacao.keys[tipoNotificacao] : CompradorTipoNotificacao.keys[tipoNotificacao];

  if (!notificacaoConfiguration) {
    return null;
  }

  const diasLimite = emailConfiguration?.diasLimite || whatsappConfiguration?.diasLimite || 0;
  return {
    tipoNotificacao,
    [entityType]: {
      id: entity.id,
    },
    whatsapp: {
      id: whatsappConfiguration ? whatsappConfiguration.id : undefined,
      enviaNotificacao: whatsappConfiguration
        ? whatsappConfiguration.enabled : notificacaoConfiguration.defaultWhatsappEnabledValue,
      desativaEdicaoNotificacao: notificacaoConfiguration.desativaEdicaoWhatsapp,
    },
    email: {
      id: emailConfiguration ? emailConfiguration.id : undefined,
      enviaNotificacao: emailConfiguration
        ? emailConfiguration.enabled : notificacaoConfiguration.defaultEmailEnabledValue,
      desativaEdicaoNotificacao: notificacaoConfiguration.desativaEdicaoEmail,
    },
    diasLimite,
    permiteEditarDiasLimite: notificacaoConfiguration.permiteEditarDiasLimite || false,
  };
}

function userHasNotificationRole(key, user, isUser) {
  if (!isUser) return true;

  return user.roles.map(r => r.name)
    .some(roleName => UserTipoNotificacao.keys[key].userRoles.includes(roleName));
}

export function buildNotificacoes(notificacoes, entity, entityType) {
  const isUser = entityType === 'user';
  const keysEnumNotificacoes = isUser ? UserTipoNotificacao.keys : CompradorTipoNotificacao.keys;
  const keys = Object.keys(keysEnumNotificacoes);

  const groupedByTipo = groupBy(notificacoes, 'tipoNotificacao');

  const configuracoesExistentes = Object.keys(groupedByTipo)
    .map(key => buildNotificacao(key, groupedByTipo[key], entity, entityType, isUser))
    .filter(n => n !== null);

  const configuracoesExtras = keys
    .filter(key => userHasNotificationRole(key, entity, isUser))
    .filter(key => !configuracoesExistentes.map(n => n.tipoNotificacao).includes(key))
    .map(key => buildNotificacao(key, [], entity, entityType, isUser))
    .filter(n => n !== null);

  return [...configuracoesExistentes, ...configuracoesExtras]
    .sort((a, b) => a.tipoNotificacao.localeCompare(b.tipoNotificacao));
}

export default { buildNotificacoes };
